var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartners(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1bb3c7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.504 12.864l-2.368-2.368c-.496-.528-1.36-.528-1.872 0l-1.936 1.936v8.464l6.16-6.16a1.29 1.29 0 00.016-1.872zM22.672 18h-2.336l-6 6h8.336c.736 0 1.328-.592 1.328-1.328v-3.344c0-.736-.592-1.328-1.328-1.328zM12.672 8H9.328C8.592 8 8 8.592 8 9.328v11.664A2.994 2.994 0 0011.008 24a2.984 2.984 0 003.008-3.008V9.328A1.349 1.349 0 0012.672 8zm-1.664 14.336a1.325 1.325 0 01-1.328-1.328c0-.736.592-1.328 1.328-1.328.736 0 1.328.592 1.328 1.328 0 .736-.608 1.328-1.328 1.328z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default "/_next/static/images/cb77576fdafc8b9e26c9038aadc4585c.svg";
export { ForwardRef as ReactComponent };